export enum HaveKitSteps {
  GENERATE = 0,
  PROCESSING = 1,
  TRANSIT = 2,
  DELIVERED = 5,
}
